<script lang="ts">
	import { t } from 'svelte-i18n';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import ProjectMap from './ProjectMap.svelte';
	import { TargetTypeEnum } from '@app/models/api/enums/TargetTypeEnum';

	export let operation: OperationModel;
</script>

<section>
	<h2>{$t('operation.realEstateProjectInfos.localization')}</h2>
	<ProjectMap {operation} />
	{#if operation.targetType === TargetTypeEnum.REAL_ESTATE}
		{@html operation.localization}
	{/if}
</section>
